import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false
window.Stimulus = application

// Auto-register every *_controller.js in this directory.
// "vue_mount_controller.js" registers as "vue-mount".
const controllers = import.meta.glob("./*_controller.js", { eager: true })

for (const [path, module] of Object.entries(controllers)) {
  const name = path
    .replace("./", "")
    .replace("_controller.js", "")
    .replaceAll("_", "-")
  application.register(name, module.default)
}

export { application }
